/**
 * FH-A11Y batch 11 (2026-09-26): Rivyo reviews widget.
 * SR13: the Reviews / Questions switch is now a set of tabs that say which one is selected
 * (arrow keys move between them). Polish: "Vote up this review" now says whose review it is.
 * Rollback: remove the ada-a11y-batch11.js line at the end of snippets/freshdesk.liquid.
 */
(function () {
  'use strict';
  if (window.__fhA11yBatch11) return;
  window.__fhA11yBatch11 = true;

  function setAttr(el, name, value) {
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  }
  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }

  var PANEL = { Review: 'wc_reviews_tab', Question: 'wc_questions_tab' };

  function syncTabs(ul) {
    var tabs = ul.querySelectorAll('button.wc_rivyo_tab_toggle');
    Array.prototype.forEach.call(tabs, function (b) {
      var sel = b.classList.contains('wc_active');
      setAttr(b, 'aria-selected', sel ? 'true' : 'false');
      setAttr(b, 'tabindex', sel ? '0' : '-1');
    });
  }

  function fixTabs() {
    document.querySelectorAll('ul.wc_review_tab_nav').forEach(function (ul) {
      var tabs = ul.querySelectorAll('button.wc_rivyo_tab_toggle');
      if (!tabs.length) return;
      setAttr(ul, 'role', 'tablist');
      setAttr(ul, 'aria-label', 'Reviews and questions');
      ul.querySelectorAll(':scope > li').forEach(function (li) { setAttr(li, 'role', 'presentation'); });
      Array.prototype.forEach.call(tabs, function (b, i) {
        var key = b.getAttribute('data-tab') || String(i);
        if (!b.id) b.id = 'fh-rivyo-tab-' + key.toLowerCase();
        setAttr(b, 'role', 'tab');
        var panel = document.getElementById(PANEL[key] || '');
        if (panel) {
          setAttr(b, 'aria-controls', panel.id);
          setAttr(panel, 'role', 'tabpanel');
          setAttr(panel, 'aria-labelledby', b.id);
        }
      });
      syncTabs(ul);
      if (ul.__fh11) return;
      ul.__fh11 = true;
      /* Keep "selected" in step when Rivyo switches tabs. */
      new MutationObserver(function () { syncTabs(ul); })
        .observe(ul, { attributes: true, attributeFilter: ['class'], subtree: true });
      /* Arrow keys, Home and End move between tabs and select them (standard tab behaviour). */
      ul.addEventListener('keydown', function (e) {
        var list = Array.prototype.slice.call(ul.querySelectorAll('button.wc_rivyo_tab_toggle'));
        var i = list.indexOf(document.activeElement);
        if (i < 0) return;
        var j = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % list.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + list.length) % list.length;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = list.length - 1;
        if (j < 0) return;
        e.preventDefault();
        list[j].click();
        list[j].focus();
        syncTabs(ul);
      });
    });
  }

  /* Polish: every vote button said "Vote up this review" with no hint of whose review it was. */
  function fixVotes() {
    document.querySelectorAll('.wc_rivyo_thumb_btn').forEach(function (b) {
      var item = b.closest('li.wc_review_widget_item, .wc_review_widget_item, .wc_question_widget_item');
      var who = txt(item && item.querySelector('.wc_review_author_name, .author'));
      var kind = /question/i.test(b.getAttribute('data-name') || '') ? 'question' : 'review';
      var up = b.getAttribute('data-like') === '1';
      var n = txt(b.querySelector('.like_count_cls'));
      var whose = who ? who + '’s ' + kind : 'this ' + kind;
      if (!who && kind === 'question') {
        var q = txt(item && item.querySelector('h4')).replace(/^Question\s*:\s*/i, '').split(' ');
        if (q[0]) whose = 'the question “' + q.slice(0, 6).join(' ') + (q.length > 6 ? '…' : '') + '”';
      }
      var label = (up ? 'Helpful: vote up ' : 'Not helpful: vote down ') + whose +
        (n !== '' ? ' (' + n + (n === '1' ? ' vote)' : ' votes)') : '');
      setAttr(b, 'aria-label', label);
    });
  }

  function runAll() {
    try { fixTabs(); } catch (e) {}
    try { fixVotes(); } catch (e) {}
  }

  var timer = 0;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = 0; runAll(); }, 60);
  }

  function start() {
    runAll();
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
    window.addEventListener('load', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
